import React from 'react';
import { CodeSnippet } from 'carbon-components-react';

const PermalinkSection: React.FC<Props> = ({ url }) => {
  return (
    <div className="permalink">
      <div className="permalink-content">
        <div className="permalink-content-text">
          Copy and share a permanent link to this enquiry. Anyone with this link
          can view the plans.
        </div>
        <div className="permalink-content-body">
          <CodeSnippet
            type="multi"
            wrapText={true}
            className="permalink-content-body-code-snippet"
          >
            {url}
          </CodeSnippet>
        </div>
      </div>
    </div>
  );
};

type Props = {
  url: string;
};

export default React.memo(PermalinkSection);
